import { render, staticRenderFns } from "./JiraTaskViewer.vue?vue&type=template&id=7a0a1a5d&scoped=true&"
import script from "./JiraTaskViewer.vue?vue&type=script&lang=js&"
export * from "./JiraTaskViewer.vue?vue&type=script&lang=js&"
import style0 from "./JiraTaskViewer.vue?vue&type=style&index=0&id=7a0a1a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a1a5d",
  null
  
)

component.options.__file = "JiraTaskViewer.vue"
export default component.exports